import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";
import SurveyReader from "../../library/SurveyReader/SurveyReader";
import {
  consentReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./Consent.store";
import { StepContent, StepLabel, Stepper, Step } from "@material-ui/core";
import ESignature from "../../library/ESignature/ESignature";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StepperWrapper = styled.div`
  & > .MuiPaper-root {
    padding: 0px;
  }
`;

export const SmartConsent = (props) => {
  const { consentSurvey, fetchConsentSurvey, submitSignedSurvey, stepData } =
    props;

  const { t } = useTranslation();

  const [currentStep, setCurrentStep] = useState(0);
  const [data, setData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const saveAndMove = (data) => {
    setCurrentStep(currentStep + 1);
    setData(data);
  };

  const handleOnComplete = (d) => {
    submitSignedSurvey(d)
      .then(() => {
        setErrorMessage("");
        setCurrentStep(currentStep + 1);
      })
      .catch((error) => {
        setErrorMessage(error);
      });
  };

  useEffect(() => {
    if (!consentSurvey) fetchConsentSurvey(stepData?.surveyId);
  }, [consentSurvey, fetchConsentSurvey, stepData]);

  return consentSurvey ? (
    <StepperWrapper>
      <Stepper activeStep={currentStep} orientation="vertical">
        <Step>
          <StepLabel>{t("appText.nextSteps.consent.adult.title")}</StepLabel>
          <StepContent>
            <SurveyReader
              surveyData={consentSurvey}
              onComplete={({ data }) => saveAndMove(JSON.stringify(data))}
            />
          </StepContent>
        </Step>
        <Step>
          <StepLabel>
            {t("appText.nextSteps.consent.electronicSignature.title")}
          </StepLabel>
          <StepContent>
            <ESignature
              onComplete={(d) => handleOnComplete(d)}
              surveyDefinitionId={consentSurvey?.id}
              responseModel={data}
              errorMessage={errorMessage}
            />
          </StepContent>
        </Step>
        <Step>
          <StepLabel>
            {t("appText.nextSteps.consent.surveyCompletion.title")}
          </StepLabel>
          <StepContent>
            <h3>{t("appText.nextSteps.consent.surveyCompletion.subtitle")}</h3>
            <p>{t("appText.nextSteps.consent.surveyCompletion.info")}</p>
          </StepContent>
        </Step>
      </Stepper>
    </StepperWrapper>
  ) : (
    <LoadingSpinner />
  );
};

export default dynamic(
  "consentReducer",
  subspaced({
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(consentReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartConsent));
